import React, { Component } from "react";
import Editors from "./Editors";

export default class Text extends Component {
  state = {
    text:
      "<h2> <b> What is cybercrime?</b></h2>" +
      "Cybercrime is a fast-growing area of criminality. Criminals" +
      "worldwide are exploiting the speed, convenience and anonymity of" +
      "the internet to carry out a diverse range of criminal activities" +
      "that know no borders. <br /> <br />" +
      "<b>Explore the slider below to find out more about cybercrime.Press the arrow to continue..</b>",
  };
  componentDidMount() {
    console.log(this.props);
  }
  onSaveData = (data) => {
    this.props.onSaveData(data);
  };
  onTextChange = (data) => {
    var currentElementId = this.props.element.id;

    var data = {
      image: this.state.image,
      text: data,
    };
    this.props.onSaveData(data, currentElementId);
  };
  render() {
    return (
      <div className="container fade-in">
        <div class="col-md-12 py-5">
          <div>
            {this.props.editMode ? (
              <Editors
              text={this.props.element.data.text !== "" ? this.props.element.data.text : "Enter your text here"}
                onTextChange={this.onTextChange}
              ></Editors>
            ) : (
              <div
                dangerouslySetInnerHTML={{
                  __html: this.props.element.data.text,
                }}
              ></div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
